<template>
  <div>
    <v-autocomplete
      class="pt-2"
      v-model="storedCohorts"
      :items="state.cohorts"
      item-text="name"
      item-value="code"
      v-on:keyup="debouncedGetData"
      clearable
      dense
      hide-details
      multiple
      outlined
      :menu-props="{ maxHeight: '400', zIndex: 13 }"
      label="Cohortes Permutive"
    ></v-autocomplete>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "CohortFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      cohorts: [],
    });

    // =>  METHODS
    const debouncedGetData = debounce(async () => {
      await getData();
    }, 500);

    const getData = async () => {
      const { data } = await axiosGet("/regie/permutive_cohorts");

      set(state, "cohorts", data);
    };

    // =>  COMPUTED
    const storedCohorts = computed({
      get: () => store.getters["regie/getPermutiveCohorts"],
      set(e) {
        store.dispatch("regie/updatePermutiveCohorts", e);
      },
    });

    // =>  WATCH
    watch(storedCohorts, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        is_multiple: true,
        is_integer: true,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      await getData();

      await synchronizeFilterWithQueryString({
        dispatcher: "regie/updatePermutiveCohorts",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: storedCohorts.value,
        is_multiple: true,
        is_integer: true,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      state,
      storedCohorts,
      debouncedGetData,
    };
  },
};
</script>

<style></style>
